export const parseNumber = (value: string): number | undefined => {
  const parsedValue = parseFloat(value);

  return isNaN(parsedValue) ? undefined : Math.abs(parsedValue);
};
